
import { styled } from "@mui/material/styles";
import { Drawer, Box, Avatar, Typography, alpha, Chip } from "@mui/material";
import { mobileTypography, palette, shadows } from "src/config/theme";
import theme from "src/config/theme";
import ButtonComponent from "src/components/shared/Button";

export const DrawerContainer = styled(Drawer)({
    display: 'flex'
});
export const DrawerHeader = styled(Box)({
    height: '72px',
    backgroundColor: theme.palette.primary.light3,
    border: `1px solid ${theme.palette.primary.light1}`,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
})
export const HeaderInner = styled(Box)({
    width: '290px',
    height: '24px',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center'
})

export const HeaderText = styled(Typography)({
    ...mobileTypography.h4
})

export const MainContainer = styled(Box)({
    display: 'flex',
    justifyContent: 'flex-start',
    margin: '32px 24px',
    flexDirection: 'column',
    gap: '30px'
})

export const Container1 = styled(Box)({
    width: '181px',
    height: '64px',
    display: 'flex',
    alignItems: 'center',
    gap: '16px',

})
export const ProfileIcon = styled(Avatar)({
    width: '64px',
    height: '64px',
    borderRadius: '12px',
    padding: '10px',
    backgroundColor: palette.primary.light3,
    color: palette.primary.main
})
export const NamegenderContainer = styled(Box)({
    width: 'auto',
    height: '42px',
    display: 'flex',
    flexDirection: 'column',
    gap: '4px',
})
export const Text = styled(Typography)({
    ...mobileTypography.h3,
    color: palette.gery.black

})
export const Texts = styled(Typography)({
    ...mobileTypography.body2,
    color: `${alpha(palette.gery.black, 0.7)}`
})

export const BorderWidth = styled(Box)({
    width: '100%',
    border: `1px solid ${alpha(palette.gery.black, 0.1)}`
})

export const TagsContainer = styled(Box)({
    width: 'auto',
    height: 'auto',
    display: 'flex',
    flexDirection: 'column',
    gap: '8px'
})
export const TagsData = styled(Box)({
    width: 'auto',
    display: 'flex',
    flexWrap: 'wrap',
    gap: '8px'
})

export const Tags = styled(Chip)({
    width: 'auto',
    height: '33px',
    borderRadius: '100px',
    padding: '4px 12px',
    backgroundColor: palette.primary.light3,
    color: palette.gery.black,
    ...mobileTypography.body2
})
export const Container2 = styled(Box)({
    display: 'flex',
    gap: '100px'
})
export const InnerContainer = styled(Box)({
    display: 'flex',
    flexDirection: 'column',
    gap: '10px'
})

export const DrawerFooter = styled(Box)({
    height: '80px',
    backgroundColor: palette.gery.white,
    borderTop: `1px solid ${alpha(palette.primary.light1, 0.1)}`,
    boxShadow: shadows[4],
    display: 'flex',
    justifyContent: 'flex-end',
    alignItems: 'center',
    padding: '12px'
})

export const EditButton = styled(ButtonComponent)({
    width: '72px',
    height: '40px',
    borderRadius: '8px',
    border: `1px solid ${alpha(palette.gery.black, 0.14)}`,
    backgroundColor: palette.primary.main,
    padding: '10px 12px',
    boxShadow: shadows[1],
    ...mobileTypography.h6,
    color: palette.gery.white,
    '&:hover': {
        color: theme.palette.primary.main,
    }

})





